import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=e748cf48"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=e748cf48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports